// extracted by mini-css-extract-plugin
export default {"container":"EducationForm-module__container--a3d6"};